import { z } from "zod";

import { RulesObjectSchema } from "@features/rules-section/model/schemas";

import { DocumentSectionSchema } from "@entities/document";

import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";
import { TitleWithIconSchema } from "@shared/content-types/schemas/pageHero.schema";
import { MetaSchema } from "@shared/content-types/schemas/pagination.schema";
import { RichTextContentSchema } from "@shared/content-types/schemas/richText.schema";

export const TiketsPageSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  titleWithIcon: TitleWithIconSchema,
  documentSection: DocumentSectionSchema.optional(),
  rulesSection: RulesObjectSchema.optional(),
});

export const TicketsTypeSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  type: z.string().min(1),
  uid: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
});

const PriceDetailSchema = z.object({
  id: z.number().int().positive(),
  oldPrice: z.number().positive().nullable().optional(),
  newPrice: z.number().positive().nullable().optional(),
  discountPercent: z.number().int().min(0).max(100).nullable().optional(),
});

export const PriceObjectSchema = z.object({
  id: z.number().positive(),
  adult: PriceDetailSchema,
  childen: PriceDetailSchema,
});

export const TicketSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  shortTitle: z.string().min(1),
  uid: z.string().min(1),
  description: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  isNew: z.boolean(),
  widgetLink: z.string().min(0).nullable(),
  image: StrapiMediaSchema,
  moreDetails: RichTextContentSchema,
  price: PriceObjectSchema,
  title: z.string().min(1),
  ticket_types: z.array(TicketsTypeSchema).min(0),
  sortOrder: z.number().int().nullable().optional(),
});

export const TicketsPageDtoSchema = z.object({
  data: TiketsPageSchema,
});

export const TicketsDtoSchema = z.object({
  data: z.array(TicketSchema).min(0),
  meta: MetaSchema,
});

export const TicketTypesDtoSchema = z.object({
  data: z.array(TicketsTypeSchema).min(0),
  meta: MetaSchema,
});
